import axios from "axios";
import { authSession } from "@/core/api/authSession";
import { getClinicalApiBaseUrl } from "@/core/api/apiHosts";

const downloadAssessmentPdf = async (
  patientId: string,
  assessmentId: string,
  path: "screening-report" | "clinical-exam",
  fallbackPrefix: string,
): Promise<{ blob: Blob; filename: string }> => {
  const token = authSession.getAccessToken();
  if (!token) {
    throw new Error("Authentication required");
  }

  const clinicalBaseUrl = getClinicalApiBaseUrl();
  if (!clinicalBaseUrl) {
    throw new Error("Regional API URL is not available. Sign in again.");
  }

  const response = await axios.get(
    `${clinicalBaseUrl}/patients/${patientId}/assessments/${assessmentId}/${path}/pdf`,
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
        "X-Client-Timezone":
          Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
      },
    },
  );

  const disposition = response.headers["content-disposition"] as string | undefined;
  const filenameMatch = disposition?.match(/filename="?([^"]+)"?/);
  const filename =
    filenameMatch?.[1] ?? `${fallbackPrefix}-${assessmentId}.pdf`;

  return { blob: response.data, filename };
};

export const downloadScreeningReportPdf = async (
  patientId: string,
  assessmentId: string,
): Promise<{ blob: Blob; filename: string }> =>
  downloadAssessmentPdf(patientId, assessmentId, "screening-report", "screening-report");

export const downloadClinicalExamPdf = async (
  patientId: string,
  assessmentId: string,
): Promise<{ blob: Blob; filename: string }> =>
  downloadAssessmentPdf(patientId, assessmentId, "clinical-exam", "clinical-exam");
